import { render, staticRenderFns } from "./ChainStitchIcon.vue?vue&type=template&id=489d80c6&scoped=true"
import script from "./ChainStitchIcon.vue?vue&type=script&lang=js"
export * from "./ChainStitchIcon.vue?vue&type=script&lang=js"
import style0 from "./ChainStitchIcon.vue?vue&type=style&index=0&id=489d80c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d80c6",
  null
  
)

export default component.exports